import { Vector3, Mesh, MeshBasicMaterial, Color, NoBlending } from 'three';
import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import { VRObject3D } from './VRObject3D';
import { youtubePlaneGeometry } from './helpers/texturesAndGeometries';


class VRLoadingScreen extends VRObject3D {

  constructor(camera, x, y, z, scene) {

    super();
    this.camera = camera;
    this.scene = scene;
    const loadingScreen = document.createElement('div');
    loadingScreen.setAttribute("class", "loading-screen-3d");
    loadingScreen.removeAttribute("style");

    const image = document.createElement('img');
    image.setAttribute("class", "loading-screen-3d__image");
    image.removeAttribute("style");
    loadingScreen.appendChild(image);
    this.image = image;

    const loader = document.createElement('div');
    loader.setAttribute("class", "loader-3d");
    loader.removeAttribute("style");
    loadingScreen.appendChild(loader);

    const p = document.createElement('p');
    p.setAttribute("class", "loading-screen__text");
    p.removeAttribute("style");
    p.textContent = $trans('info-waiting-for-screen-share');
    loadingScreen.appendChild(p);

    const object = new CSS3DObject(loadingScreen);
    // Position the loading screen at the same world position as the target object (e.g. VRScreenShare)
    object.position.copy(new Vector3(x, y, z));
    // Face the camera so the loading screen is oriented correctly in world space
    if (this.camera) {
      object.lookAt(this.camera.position);
    }

    object.type = 'loadingScreen';
    this.object = object;
    // Mesh remains centered within the CSS3DObject; no extra offset needed
    return this;
  }
  remove() {
    this.scene.remove(this.object);
  }
  add(imageSrc) {
    this.scene.add(this.object);
    if (imageSrc) {
      this.image.src = imageSrc;
      this.image.style.display = 'block';
    } else {
      this.image.style.display = 'none';
    }
  }

}

export { VRLoadingScreen };